﻿import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { User } from '../../../_models';
import { AuthenticationService } from '../../../_services';
import { RestService } from 'src/app/_services/rest.service';

@Component({ templateUrl: 'home.component.html' })
export class HomeRootComponent {


    records;

    primeros;
    

    constructor(private restService: RestService) {
        this.restService.getAll('/rest-api/user/record').subscribe(data => {
            this.records = data;
        });
        this.restService.getAll('/rest-api/user/resultado?puesto=1').subscribe(data => {
            this.primeros = data;
        });
    }

    saveAllRecord() {
        this.records.data.forEach(element => {
            this.restService.post('/rest-api/user/record', element).subscribe(
                data => {
                    console.log(data);
                });
        });
    }

    saveAllResultados() {
        this.primeros.data.forEach(element => {
            this.restService.post('/rest-api/user/resultado', element).subscribe(
                data => {
                    console.log(data);
                });
        });

    }


}
